import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Subscription } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-fixed-previous-meeting',
  templateUrl: './fixed-previous-meeting.component.html',
  styleUrls: ['./fixed-previous-meeting.component.css']
})
export class FixedPreviousMeetingComponent implements OnInit, OnDestroy {

  options: any
  optionsTwo: any
  today : any
  currentDate : any
  currentDateTwo : any

  mediaSub!: Subscription;
  deviceXs!: boolean;
  deviceSm!: boolean;
  deviceMd!: boolean;
  deviceLg!: boolean;
  deviceXl!: boolean;

  constructor(private readonly breakpointObserver: BreakpointObserver,private router : Router, public mediaObserver : MediaObserver) { }

  boolean = false

  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;

  shown: 'native' | 'hover' | 'always' = 'native';

  ngOnInit(): void {
    this.options = {
      month : 'short',
      day : 'numeric',
      year : 'numeric'
    }

    this.optionsTwo = {
      weekday : 'long',
      month : 'short',
      day : 'numeric',
      year : 'numeric'
    }
  
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US",this.options)
    this.currentDateTwo = this.today.toLocaleDateString("en-US",this.optionsTwo)
  this.mediaSub = this.breakpointObserver.observe([
    Breakpoints.XSmall,
    Breakpoints.Small,
    Breakpoints.Medium,
    Breakpoints.Large,
    Breakpoints.XLarge
  ]).subscribe(result => {
    const breakpoints = result.breakpoints;

    this.deviceXs = breakpoints[Breakpoints.XSmall] || false;
    this.deviceSm = breakpoints[Breakpoints.Small] || false;
    this.deviceMd = breakpoints[Breakpoints.Medium] || false;
    this.deviceLg = breakpoints[Breakpoints.Large] || false;
    this.deviceXl = breakpoints[Breakpoints.XLarge] || false;
  });
  }

  navigateTo(){
    this.router.navigate(['instantMeeting'])
  }

  ngOnDestroy(){
    this.mediaSub?.unsubscribe();
  }

}
